// Force MUI styles init before any MUI component imports (workaround for Vite/esbuild chunk-splitting bug)
import '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@components/App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
